import { zodResolver } from "@hookform/resolvers/zod";
import { Button, Card, Col, Form, Row } from "antd";
import * as React from "react";
import { useForm } from "react-hook-form";
import * as z from "zod";
import config from "../../../config";
import { schemaFormAction } from "../../../features/forms/schemas/schemaFormAction";
import { UserForList } from "../../../types/user";
import { isDev } from "../../../utils/dev";
import Br from "../../ui/Br";
import spacing from "../../ui/spacingConfig";
import FieldDate from "../fields/FieldDate";
import FieldInput from "../fields/FieldInput";
import FieldSelect from "../fields/FieldSelect";
import FieldTextArea from "../fields/FieldTextArea";
import FieldUpload from "../fields/FieldUpload/FieldUpload";
import styles from "./FormAction.module.scss";
import { getLabel } from "../utils/ShowIsRequired";
import { get } from "lodash";

export type SchemaFormAction = z.infer<typeof schemaFormAction>;

type Props = {
  onSubmit: (data: SchemaFormAction, stayToCreateAfterSuccess: boolean) => void;
  defaultValues: SchemaFormAction;
  isLoading: boolean;
  performers: UserForList[];
  isEditMode?: boolean;
};

const FormActions: React.FC<Props> = ({
  onSubmit,
  defaultValues,
  isLoading,
  performers,
  isEditMode,
}) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm<SchemaFormAction>({
    defaultValues,
    resolver: zodResolver(schemaFormAction),
  });

  const formValues = watch(); // Get the form values state
  if (isDev) {
    console.log("Action: formValues", formValues);
    console.log("Action: errors", errors);
  }

  return (
    <>
      <Form
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 20 }}
        labelAlign="left"
        colon={false}
        className={styles.root}
      >
        <Row className={styles.firstRow}>
          <Col span={spacing.m}>
            <Card title="Description" bordered={false}>
              <FieldInput<SchemaFormAction>
                errorMessage={errors?.title?.message}
                control={control}
                name="title"
                label={getLabel("Titre", "title")}
                placeholder="Titre..."
              />
              <FieldTextArea<SchemaFormAction>
                errorMessage={errors?.description?.message}
                control={control}
                name="description"
                label={getLabel("Description", "description")}
                placeholder="Description..."
                className={styles.textArea}
              />
              <FieldSelect<SchemaFormAction>
                errorMessage={errors?.causeType?.message}
                control={control}
                name="causeType"
                label={getLabel("Type d'action", "causeType")}
                placeholder=""
                options={
                  config.actionCauseTypes?.map((cause) => ({
                    label: cause.label,
                    value: String(cause.value),
                  })) || []
                }
              />
              <FieldInput<SchemaFormAction>
                errorMessage={errors?.effacity?.message}
                control={control}
                name="effacity"
                label={getLabel("CritÃ¨re d'EfficacitÃ©", "effacity")}
                placeholder="CritÃ¨re d'EfficacitÃ©..."
              />
              <FieldDate<SchemaFormAction>
                errorMessage={errors?.dateAsked?.message}
                control={control}
                name="dateAsked"
                label={getLabel("Date d'Ã©chÃ©ance", "dateAsked")}
              />
              <FieldSelect<SchemaFormAction>
                errorMessage={errors?.performer?.message}
                control={control}
                name="performer"
                label={getLabel("Attribution", "performer")}
                placeholder="Attribuer Ã "
                options={
                  performers?.map((user) => ({
                    label: user.fullname,
                    value: String(user.id),
                  })) || []
                }
              />
            </Card>
          </Col>
        </Row>
        <Br height={spacing.xl} />
        {!isEditMode && (
          <Row>
            <Col span={spacing.m}>
              <Card title="PiÃ¨ces jointes" bordered={false}>
                <FieldUpload<SchemaFormAction>
                  errorMessage={errors.attachedFiles?.message}
                  name="attachedFiles"
                  control={control}
                  listType="picture"
                  label={getLabel("", "attachedFiles")}
                  placeholder=""
                />
              </Card>
            </Col>
          </Row>
        )}
        <Row justify="end" gutter={spacing.m}>
          {!isEditMode && (
            <Col>
              <Button
                type="primary"
                style={{ marginTop: "40px" }}
                loading={isLoading}
                onClick={handleSubmit((data) => onSubmit(data, true))}
              >
                Ajouter une autre action
              </Button>
            </Col>
          )}
          <Col>
            <Button
              type="primary"
              style={{ marginTop: "40px" }}
              loading={isLoading}
              onClick={handleSubmit((data) => onSubmit(data, false))}
            >
              {isEditMode ? "Modifier" : "Publier"}
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default FormActions;
